import React from "react";
import "./MultiActionCard.scss";
import CardPreview from "components/CardPreview/CardPreview";
const MultiActionCard = ({ title, config, data }: any) => {
  return (
    <div className="multi-action-card-container">
      <h2 className="card-title">{title}</h2>
      <div>
        <CardPreview
          type={config?.previewType}
          icon={config?.previewIcon}
          valueDefinitions={config?.previewValueDefinitions}
          data={data}
        />
      </div>
    </div>
  );
};

export { MultiActionCard };
